var _path, _path2, _path3, _path4, _path5, _g, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgResetPasswordMail(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 113,
    height: 111,
    viewBox: "0 0 113 111",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M56.2932 92.6453C80.3606 92.6453 99.8788 73.2389 99.8788 49.2746C99.8788 25.3105 80.3606 5.90381 56.2932 5.90381C32.2257 5.90381 12.7075 25.3105 12.7075 49.2746C12.7075 73.2389 32.2257 92.6453 56.2932 92.6453Z",
    fill: "#F8F4F9"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M98.765 28.5448C100.427 28.5448 101.773 27.1954 101.773 25.5309C101.773 23.8664 100.427 22.517 98.765 22.517C97.1038 22.517 95.7566 23.8664 95.7566 25.5309C95.7566 27.1954 97.1038 28.5448 98.765 28.5448Z",
    fill: "#F8F4F9"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M95.7572 18.768C96.8916 18.768 97.8117 17.8465 97.8117 16.7098C97.8117 15.573 96.8916 14.6515 95.7572 14.6515C94.6221 14.6515 93.7026 15.573 93.7026 16.7098C93.7026 17.8465 94.6221 18.768 95.7572 18.768Z",
    fill: "#F8F4F9"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M12.5477 25.5309C13.6824 25.5309 14.6023 24.6093 14.6023 23.4726C14.6023 22.3358 13.6824 21.4143 12.5477 21.4143C11.413 21.4143 10.4932 22.3358 10.4932 23.4726C10.4932 24.6093 11.413 25.5309 12.5477 25.5309Z",
    fill: "#F8F4F9"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M7.92521 70.8131C10.0325 70.8131 11.7408 69.1017 11.7408 66.9906C11.7408 64.8795 10.0325 63.1681 7.92521 63.1681C5.81791 63.1681 4.10962 64.8795 4.10962 66.9906C4.10962 69.1017 5.81791 70.8131 7.92521 70.8131Z",
    fill: "#F8F4F9"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_1119_35381)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M96.4492 38.5371V78.3359C96.4492 78.4998 96.4492 78.5822 96.4492 78.7461C96.367 81.044 95.3023 83.0134 93.6638 84.4086C92.2711 85.6391 90.3876 86.4595 88.3396 86.4595H24.2038C22.8114 86.4595 21.5008 86.1316 20.3541 85.4752C19.8626 85.2289 19.3711 84.9004 18.9616 84.4902C18.0606 83.7521 17.2415 82.6848 16.8319 81.5358C16.5043 80.7154 16.2585 79.8127 16.2585 78.91V38.5371C16.2585 38.5371 19.6168 35.665 24.4496 31.7262C29.4462 27.5411 35.999 22.1252 41.7327 17.3658C45.0091 14.5758 44.6815 14.904 49.7599 10.6369C53.6097 7.35458 59.2615 7.35458 63.1114 10.6369C64.0942 11.4575 65.1591 12.4423 66.142 13.2629C68.2717 14.9861 70.5652 16.9555 73.0225 19.007C78.1828 23.2741 83.835 28.0335 88.2582 31.7262C92.7628 35.4188 96.039 38.2088 96.4492 38.5371Z",
    fill: "url(#paint0_linear_1119_35381)"
  }))), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M88.2574 31.6441V45.9223L74.2512 54.3744L70.0736 56.9183L61.2272 62.2521L57.0498 64.796L55.2478 65.8627L53.5277 64.796L49.596 62.2521L41.1592 56.9183L37.2275 54.3744L24.2856 46.2506V31.7261C29.2822 27.541 35.835 22.1251 41.5688 17.3657L72.9404 18.9249C78.1828 23.274 83.8342 27.9514 88.2574 31.6441Z",
    fill: "#90388B"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M85.4728 20.3199V45.43L72.6948 53.0615L68.9269 55.3592L60.8178 60.1186L57.0499 62.4163L55.4117 63.319L53.8554 62.4163L50.2513 60.1186L42.5518 55.3592L38.9477 53.0615L27.1526 45.6762V20.3199C27.1526 17.694 29.2823 15.5604 31.9853 15.5604H80.6402C83.2612 15.4784 85.4728 17.694 85.4728 20.3199Z",
    fill: "white"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M16.5862 38.3729L55.0841 40.9168L95.8754 38.3729L94.3191 45.6762C94.3191 45.6762 55.9851 65.6987 56.2308 65.6987C56.4766 65.6987 16.6681 41.9836 16.6681 41.9836L16.5862 38.3729Z",
    fill: "url(#paint1_linear_1119_35381)"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M93.746 84.4086C92.3533 85.6391 90.4698 86.4595 88.4218 86.4595H24.2038C22.8114 86.4595 21.5008 86.1316 20.3541 85.4752C19.8626 85.2289 19.3711 84.9003 18.9616 84.4902C18.0606 83.7514 17.2415 82.6847 16.8319 81.5358C16.5043 80.7154 16.2585 79.8127 16.2585 78.91V78.8284V38.5371L20.4359 41.0809L56.3128 62.3343L57.2957 62.9087L57.3776 62.9908L89.5687 82.0283L93.746 84.4086Z",
    fill: "url(#paint2_linear_1119_35381)"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M57.2955 61.6777V64.4677L20.3539 85.4751C19.8625 85.2288 19.371 84.9002 18.9614 84.4901C18.0604 83.752 17.2413 82.6847 16.8318 81.5364L52.7904 60.2007L55.9031 62.1701L56.3126 62.3342L57.2955 61.6777Z",
    fill: "url(#paint3_linear_1119_35381)"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M16.2585 38.5371L56.3128 62.3343",
    stroke: "white",
    strokeMiterlimit: 10
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M96.4484 38.5371V78.7461C96.3669 81.044 95.3022 83.0133 93.6637 84.4086C92.2711 85.6391 90.3875 86.4595 88.3395 86.4595H24.2037C22.8112 86.4595 21.5006 86.1316 20.3539 85.4752C19.8624 85.2289 19.371 84.9003 18.9614 84.4902L23.0569 82.0283L55.2478 62.9908L56.3126 62.3343L57.2955 61.7599L92.1896 40.9989L96.4484 38.5371Z",
    fill: "url(#paint4_linear_1119_35381)"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M96.4484 38.5371L57.2955 61.6778L56.3126 62.3343L55.2478 62.9908L18.9614 84.4086",
    stroke: "white",
    strokeMiterlimit: 10
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M86.7833 66.6834H65.4867C64.9953 66.6834 64.5857 66.273 64.5857 65.7807C64.5857 65.2884 64.9953 64.8781 65.4867 64.8781H86.7833C87.2749 64.8781 87.6844 65.2884 87.6844 65.7807C87.7665 66.273 87.3571 66.6834 86.7833 66.6834Z",
    fill: "#E8D6EB"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M86.7833 72.8377H65.4867C64.9953 72.8377 64.5857 72.4275 64.5857 71.9351C64.5857 71.4427 64.9953 71.0325 65.4867 71.0325H86.7833C87.2749 71.0325 87.6844 71.4427 87.6844 71.9351C87.7665 72.4275 87.3571 72.8377 86.7833 72.8377Z",
    fill: "#E8D6EB"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M54.2628 46.9336C53.628 46.9336 53.0305 46.6999 52.545 46.1934L44.292 37.584C43.3584 36.61 43.3584 34.9738 44.292 33.9999C45.2256 33.026 46.794 33.026 47.7277 33.9999L54.2628 40.8174L69.6486 24.806C70.5821 23.8321 72.1506 23.8321 73.0842 24.806C74.018 25.7799 74.018 27.4161 73.0842 28.3901L55.9806 46.1934C55.5325 46.6999 54.8977 46.9336 54.2628 46.9336Z",
    fill: "url(#paint5_linear_1119_35381)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_1119_35381",
    x: 6.25854,
    y: 2.17517,
    width: 100.191,
    height: 98.2843,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 5
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.909804 0 0 0 0 0.839216 0 0 0 0 0.921569 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_1119_35381"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_1119_35381",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1119_35381",
    x1: 93.2681,
    y1: 8.17518,
    x2: 18.7039,
    y2: 8.44111,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9B4C97"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7E3080"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_1119_35381",
    x1: 56.0774,
    y1: 64.8478,
    x2: 56.0774,
    y2: 50.5342,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.00870001,
    stopColor: "#E8D6EB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_1119_35381",
    x1: 54.9773,
    y1: 37.4286,
    x2: 54.9773,
    y2: 86.9757,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9964,
    stopColor: "#F8F4F9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_1119_35381",
    x1: 36.9854,
    y1: 84.6881,
    x2: 36.9854,
    y2: 71.449,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9913,
    stopColor: "#E8D6EB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_1119_35381",
    x1: 57.68,
    y1: 37.4286,
    x2: 57.68,
    y2: 86.9757,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9964,
    stopColor: "#F8F4F9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_1119_35381",
    x1: 72.5868,
    y1: 24.0756,
    x2: 44.5127,
    y2: 24.2047,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9B4C97"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7E3080"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgResetPasswordMail);
export default __webpack_public_path__ + "static/media/reset-password-mail.c5c76089d79eb29c10b8c484438ff17a.svg";
export { ForwardRef as ReactComponent };